import { render, staticRenderFns } from "./productPrice.vue?vue&type=template&id=6fc6477a&scoped=true&"
import script from "./productPrice.vue?vue&type=script&lang=js&"
export * from "./productPrice.vue?vue&type=script&lang=js&"
import style0 from "./productPrice.vue?vue&type=style&index=0&id=6fc6477a&lang=scss&scoped=true&"
import style1 from "./productPrice.vue?vue&type=style&index=1&id=6fc6477a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6477a",
  null
  
)

export default component.exports